import { dialog, modelName, sessionStorageKeyAuthorizationToken, unknownLabel } from '../../../common/const/commonConst';
import { responseType } from '../../../common/type/ResponseType';
import { HandlerOutputType } from '../../../common/type/HandlerType';
import { getSessionStorage } from '../../../common/utils/sessionStorageHandler';
import { nonNullable } from '../../../common/utils/nonNullable';
import { isResponseTypeError, isResponseTypeSessionNotExist } from '../../../common/utils/responseTypeChecker';
import { redirectToLogin } from '../../../common/utils/redirectToLogin';

import { RequestParameterType } from '../type/RequestParameter';
import { EventVideoInfoType } from '../type/EventVideoInfoType';
import { queryGetEventVideo } from '../api/queryGetEventVideo';

/**
 * Offseg・G500Liteのイベント映像を取得する
 */
export const getEventVideoHandler = async (requestParams: RequestParameterType): Promise<HandlerOutputType<EventVideoInfoType[]>> => {
	// 認証トークンを取得する
	const authorizationToken = getSessionStorage(sessionStorageKeyAuthorizationToken);

	if (!authorizationToken) {
		return [dialog.systemError, undefined];
	}

	const getOffsegEventVideoInput = {
		authorizationToken: authorizationToken,
		organizationId: requestParams.offsegOrganizationId ? requestParams.offsegOrganizationId : undefined,
		driverId: requestParams.offsegDriverId ? requestParams.offsegDriverId : undefined,
		startDate: requestParams.startDate,
		endDate: requestParams.endDate,
	};

	const getG500LiteEventVideoInput = {
		authorizationToken: authorizationToken,
		organizationId: requestParams.g500LiteOrganizationId ? requestParams.g500LiteOrganizationId : undefined,
		driverId: requestParams.g500LiteDriverId ? requestParams.g500LiteDriverId : undefined,
		startDate: requestParams.startDate,
		endDate: requestParams.endDate,
	};

	try {
		// Offseg・G500Liteのイベント映像一覧を取得する
		const [isApiError, eventVideo] = await queryGetEventVideo(getOffsegEventVideoInput, getG500LiteEventVideoInput, authorizationToken);

		if (isApiError || !eventVideo || isResponseTypeError(eventVideo)) {
			return [dialog.apiError, undefined];
		}

		if (isResponseTypeSessionNotExist(eventVideo)) {
			redirectToLogin();
		}

		// 取得結果の存在チェック
		if (
			eventVideo.getOffsegEventVideo.responseType === responseType.notExistApiResponseData &&
			eventVideo.getG500LiteEventVideo.responseType === responseType.notExistApiResponseData
		) {
			return [dialog.notExistSearchResult, undefined];
		}

		const eventVideoInfoList: EventVideoInfoType[] = [];

		// modelを追加
		eventVideo.getOffsegEventVideo.eventVideos.filter(nonNullable).forEach((item) => {
			const eventVideoInfo = {
				occurrenceDatetime: item.occurrenceDatetime || unknownLabel, // yyyy/MM/dd hh:mm:ss形式
				organizationName: item.organizationName || unknownLabel,
				driverName: item.driverName || unknownLabel,
				carCode: item.carCode || unknownLabel,
				numberPlate: item.numberPlate || unknownLabel,
				eventType: item.eventType || unknownLabel,
				gValue: item.gValue || unknownLabel,
				hiyariLevel: item.hiyariLevel || unknownLabel,
				hiyariResult: item.hiyariResult || unknownLabel,
				legalSpeed: item.legalSpeed || unknownLabel,
				overspeed: item.overspeed || unknownLabel,
				model: modelName.offseg,
			};
			eventVideoInfoList.push(eventVideoInfo);
		});

		eventVideo.getG500LiteEventVideo.eventVideos.filter(nonNullable).forEach((item) => {
			const eventVideoInfo = {
				occurrenceDatetime: item.occurrenceDatetime || unknownLabel, // yyyy/MM/dd hh:mm:ss形式
				organizationName: item.organizationName || unknownLabel,
				driverName: item.driverName || unknownLabel,
				carCode: item.carCode || unknownLabel,
				numberPlate: item.numberPlate || unknownLabel,
				eventType: item.eventType || unknownLabel,
				gValue: item.gValue || unknownLabel,
				hiyariLevel: item.hiyariLevel || unknownLabel,
				hiyariResult: item.hiyariResult || unknownLabel,
				legalSpeed: item.legalSpeed || unknownLabel,
				overspeed: item.overspeed || unknownLabel,
				model: modelName.g500Lite,
			};
			eventVideoInfoList.push(eventVideoInfo);
		});

		console.log(eventVideoInfoList);
		return [dialog.success, eventVideoInfoList];
	} catch (err: unknown) {
		return [dialog.systemError, undefined];
	}
};
